import {
  personSignupCheckPhone,
  postPersonalUserSignUp,
  postUserCheckCode,
  postUserSignUp,
} from "@/api/signin";
import { AsarButton, Loader } from "@/components";
import Timer from "@/components/signin/timer";
import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import persian from "react-date-object/calendars/persian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import { DateObject } from "react-multi-date-picker";
import { toast } from "react-toastify";
import VerificationInput from "react-verification-input";
import EnterPhone from "./personSignupComponents/EnterPhone";
import GeneralInfo from "./personSignupComponents/GeneralInfo";
import PersonalInfo from "./personSignupComponents/PersonalInfo";
import RelationInfo from "./personSignupComponents/RelationInfo";
import {
  generalInfoValidationSchema,
  personalInfoValidationSchema,
  phoneValidationSchema,
  relationInfoValidationSchema,
} from "./personSignupComponents/validationSchema";

function PersonSignupForm({ level, setLevel }) {
  const [reminder, setReminder] = useState();
  const [token, setToken] = useState();
  const [code, setCode] = useState();
  const [phone, setPhone] = useState();
  const md = useMediaQuery("(max-width:450px)");

  const onSubmit = async (values, actions) => {
    if (level === 1) {
      setPhone(values.phone);
      personSignupCheckPhone({
        phone: values.phone,
      })
        .then((res) => {
          setReminder(parseInt(res.reminder));
          setToken(res.token);
          setLevel(2);
        })
        .catch(() => {})
        .finally(() => actions.setSubmitting(false));
    } else if (level !== 5) {
      if (level === 3) {
        postUserSignUp({
          nid: values.nid,
          phone: values.phone,
        })
          .then(() => {
            setLevel(level + 1);
          })
          .catch((e) => {
            console.log(e);
          });
      } else setLevel(level + 1);
    } else {
      postPersonalUserSignUp({
        ...values,
        birthDay: values.birthDay
          .convert(persian, gregorian_en)
          .format("YYYY/MM/DD"),
        token: token,
      })
        .then(() => {
          setLevel(6);
        })
        .catch(() => {})
        .finally(() => actions.setSubmitting(false));
    }
  };

  const isDateValid = (date) => {
    const strings = date?.split("/");
    if (strings.length != 3) return false;
    const numbers = strings.map(Number);
    const [year, month, day] = numbers;

    if (numbers.some((number) => isNaN(number))) {
      return false;
    }

    if (month > 12 || month < 0) return false;
    if (day < 0 || day > 31) return false;
    if (year < 1200 || year > 1500) return false;
    if (strings.some((val) => val.startsWith("00"))) return false;
    return true;
  };

  return (
    <>
      <Formik
        onSubmit={onSubmit}
        initialValues={{ sex: "MALE" }}
        validationSchema={
          level === 1
            ? phoneValidationSchema
            : level === 3
              ? personalInfoValidationSchema
              : level === 4
                ? generalInfoValidationSchema
                : relationInfoValidationSchema
        }
        validateOnBlur={false}
        validateOnChange={false}
        validateOnMount={false}
      >
        {({ isSubmitting, submitForm, values, setValues }) => (
          <Form
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            <Grid
              display={"flex"}
              alignItems={"center"}
              flexDirection={"column"}
              gap={"16px"}
            >
              {level === 1 && (
                <EnterPhone
                  submitForm={submitForm}
                  form={values}
                  setForm={setValues}
                  isSubmitting={isSubmitting}
                />
              )}
              {level === 3 && <PersonalInfo />}
              {level === 4 && <GeneralInfo />}
              {level === 5 && <RelationInfo />}
              {(level === 3 || level === 4 || level === 5) && (
                <Box
                  mt={"16px"}
                  display="flex"
                  sx={{ width: "100%", marginTop: "10px" }}
                  justifyContent={"space-between"}
                >
                  <Button
                    onClick={() => {
                      setLevel(level === 3 ? 1 : level - 1);
                    }}
                    sx={{ color: "var(--emr-primary)" }}
                    variant="text"
                  >
                    {level === 3 ? "ویرایش شماره تلفن" : "مرحله قبل"}
                  </Button>
                  <AsarButton
                    style={{
                      width:
                        // level === 3
                        //   ? "calc(100% - 150px)"
                        //   : "calc(100% - 100px)",
                        "unset",
                    }}
                    onClick={() => {
                      if (
                        level === 3 &&
                        values.birthDay &&
                        !(values.birthDay instanceof DateObject)
                      ) {
                        if (!isDateValid(values.birthDay)) {
                          toast.error("تاریخ معتبر نمی باشد");
                          return;
                        }

                        setValues({
                          ...values,
                          birthDay: new DateObject({
                            date: values.birthDay,
                            format: "YYYY/MM/DD",
                            calendar: persian,
                          }).millisecond,
                        });
                      }
                      submitForm();
                    }}
                  >
                    <Typography fontSize="16px" color="white">
                      مرحله بعد
                    </Typography>
                  </AsarButton>
                </Box>
              )}
              {isSubmitting && <Loader />}
            </Grid>
          </Form>
        )}
      </Formik>

      {level === 2 && (
        <Grid
          display={"flex"}
          alignItems={"center"}
          flexDirection={"column"}
          width={"100%"}
          gap={"16px"}
        >
          <VerificationInput
            onChange={setCode}
            length={6}
            validChars="0-9"
            removeDefaultStyles
            classNames={{
              container: md
                ? "phone-verification-container"
                : "verification-container",
              character: "character",
              characterInactive: "character--inactive",
              characterSelected: "character--selected",
            }}
          />

          <AsarButton
            onClick={() => {
              if (code) {
                postUserCheckCode({
                  token: token,
                  phone: phone,
                  code: code,
                })
                  .then(() => setLevel(3))
                  .catch((e) => toast.error(e));
              }
            }}
          >
            <Typography fontSize="16px" color="white" ml="10px">
              تایید کد
            </Typography>
          </AsarButton>
          {reminder && reminder > 0 && (
            <Timer
              initialMinute={Math.floor(reminder / 60)}
              initialSeconds={reminder % 60}
            />
          )}

          <Button
            onClick={() => setLevel(1)}
            variant="text"
            sx={{ color: "var(--emr-text-bold)" }}
          >
            ویرایش شماره تلفن همراه
          </Button>
        </Grid>
      )}
    </>
  );
}

export default PersonSignupForm;
